export default "__VITE_ASSET__oYdNUojE__"